<template>
  <div>
    <CRow>
      <CCol sm="6">
        <div class="card-title mb-3">
          {{ $t("role.logistics.Connections.Sales.title") }}
        </div>
      </CCol>
    </CRow>

    <CRow v-if="connectionData && connectionData.length > 0" class="p-3">
      <Header
        :data="[
          $t('models.logistics.connections.market'),
          $t('models.logistics.connections.country'),
          $t('models.logistics.connections.phone'),
          'URL',
          $t('models.logistics.connections.contacts'),
          $t('models.logistics.connections.serviceZone'),
        ]"
      />
      <Row
        v-for="(item, index) in connectionData"
        :key="index"
        :data="[
          {
            data: marketName(item.market.role.name, item.market.role.id),
            type: 'html',
          },
          { data: item.market.role.country, type: 'text' },
          { data: item.market.role.tel, type: 'text' },
          { data: item.market.role.url, type: 'text' },
          { data: item.market.role.info_contact, type: 'text' },
          { data: item.market.role.desc_zone, type: 'text' },
        ]"
        :border="true"
        :topAligned="true"
      >
      </Row>
    </CRow>
  </div>
</template>
<script>
import Row from "../../../common/table/Row.vue";
import Header from "../../../common/table/Header.vue";
import { apiGet } from "../../../helpers/apiHelper";

export default {
  components: {
    Row,
    Header,
  },
  data() {
    return {
      connectionData: [],
    };
  },
  methods: {
    marketName(name, id) {
      return name ? `<strong>${name}</strong><br>M-${id}` : "";
    },

    async fetchData() {
      const response = await apiGet(
        "role_producer_connections",
        [this.$store.state.role.id],
        null
      );
      if (response && response.status === 200) {
        this.connectionData = response.data.Items;
      } else {
        this.$store.dispatch("toaster/add", {
          title: this.$t("role.finance.invoicesSettings.attention"),
          text: "Error loading planning data",
          color: "danger",
          autohide: true,
        });
      }
    },
  },

  async created() {
    await this.fetchData();
  },
};
</script>
